module.exports = __webpack_public_path__ + "9c1cf05be8b3bb1507b97972a2560f20.pdf";